import styled from 'styled-components'

export const Svg = styled.svg`
  ${props => props.onClick ? `
  cursor: pointer;
  ` : ''}
`